var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button-element',{attrs:{"size":"small","type":"danger"},on:{"click":_vm.openModal}},[_c('fa-icon',{attrs:{"fixed-width":"","icon":"trash"}})],1),_c('delete-confirmation-modal',{ref:"modal",attrs:{"title":"Supprimer produit"},on:{"delete":_vm.deleteItem}},[_vm._v(" Voulez-vous supprimer ce produit de la commande? ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }